import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { COMMON_PAGE } from '../services/Macro'
import '../css/privacy.policy.css'

class ContactComponent extends React.Component<WithTranslation> {

    state = {
        email: COMMON_PAGE.EMAIL,
        address: COMMON_PAGE.ADDRESS,
        phone: COMMON_PAGE.PHONE,
        lastUpdate: COMMON_PAGE.LAST_UPDATE,
    }

    render() {
        const { i18n, lan } = this.props as any
        if (lan) {
            if (lan == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
        else {
            const lang = i18n.language
            if (lang == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
    }

    renderCn() {
        return (
            <>
                <div>
                    <b>电子邮件：</b><text className='contact'>{this.state.email}</text>
                </div>
                <div>
                    <b>电话：</b><text className='contact'>{this.state.phone}</text>
                </div>
                <div>
                    <b>地址：</b><text className='contact'>{this.renderAddress()}</text>
                </div>
                {/* <div>
                    <b>最新更新：</b>{this.state.lastUpdate}
                </div> */}
            </>
        )
    }

    renderEn() {
        return (
            <>
                <div>
                    <b>Email: </b><text className='contact'>{this.state.email}</text>
                </div>
                <div>
                    <b>Phone: </b><text className='contact'>{this.state.phone}</text>
                </div>
                <div>
                    <b>Address: </b><text className='contact'>{this.renderAddress()}</text>
                </div>
                {/* <div>
                    <b>Latest update: </b>{this.state.lastUpdate}
                </div> */}
            </>
        )
    }

    renderAddress() {
        return (
            <>
                {this.state.address.map((item, index) => (
                    <div>{item}</div>
                ))}
            </>
        )
    }
}

export const ContactComp = withTranslation()(ContactComponent)